import { useEffect, useState } from "react";
import {
  concatenateAnalyticsColours,
  analyticsFormatType,
} from "./AnalyticsUtils";

export const MechanicalReportAnalytics = (
  reportType:
    | "Standard"
    | "ElectricHybrid"
    | "EssentialChecks"
    | "FullInspection"
    | "NoReport",
  conditionSummaries: any
) => {
  const [analyticsData, setAnalyticsData] = useState([]);

  useEffect(() => {
    function separateReportTypesAnalytics() {
      let data = conditionSummaries ?? [];

      let analyticsObj = [""];

      if (data.length > 0) {
        // condition report
        const result = data.reduce(
          (
            acc: { reportType?: string; colour: any }[],
            d: { reportType: string; severityType: string }
          ) => {
            const found = acc.find((a) => a.reportType === d.reportType);
            const dataArr = [d.severityType];

            if (!found) {
              acc.push({ reportType: d.reportType, colour: dataArr });
            } else {
              found.colour.push(dataArr[0]);
            }

            return acc;
          },
          []
        );

        const mapper = result.map((item) => {
          let filtered = [];
          let colourArray = item.colour;

          colourArray.forEach((x: string) => {
            if (x === "RED" || x === "AMBER") {
              filtered.push(
                analyticsFormatType[item.reportType] + "|" + x.toLowerCase()
              );
            }
          });

          if (filtered.length === 0) {
            filtered.push(analyticsFormatType[item.reportType] + "|green");
          }

          return filtered;
        });

        if (mapper.length > 0) {
          analyticsObj = [].concat.apply([], mapper);
        } else {
          analyticsObj = [analyticsFormatType[reportType]];
        }

        analyticsObj = concatenateAnalyticsColours(analyticsObj, "assured");
        analyticsObj = concatenateAnalyticsColours(analyticsObj, "ev_hybrid");
        analyticsObj = concatenateAnalyticsColours(analyticsObj, "essential");
        if (analyticsObj.length > 1 && analyticsObj[0].includes("essential")) {
          analyticsObj.reverse();
        }
      } else {
        //condition report - not available
        analyticsObj = [analyticsFormatType[reportType] + "|none"];
      }
      setAnalyticsData(analyticsObj);
    }

    separateReportTypesAnalytics();
  }, []);

  if (analyticsData.length > 0) {
    return analyticsData;
  }
};
